const log = {
    invalid_type: 'Loại log không hợp lệ.',
    invalid_time_window: '`end_time` phải sau `start_time`.',
};
export default Object.freeze(log);
